module.exports = __webpack_public_path__ + "static/media/transparentHalloween.c52bb201.png";